import React, {useState} from 'react';
import {RiMenu3Line, RiCloseLine} from 'react-icons/ri';
// Above is the caller from React icon
import logo from '../../assets/op4.png';
import './navbar.css'

// This variable to save from lots of dupllicate, therefore to make variable and next time, add them on location that you want 
const Menu = () =>(
  <>
      <p><a href="#home">Home</a></p>
      <p><a href="#about">About</a></p>
      <p><a href="#service">Service</a></p>
      <p><a href="#portfolio">Portfolio</a></p>
      <p><a href="#contact">Contact</a></p>
  </>
)

// BEM -> BLOCK ELEMENT MODIFIER
const Navbar = () => {
  // useState command
  const [toggleMenu, setToggleMenu] =useState(false);

  return (
    <div className="ac__navbar">
      <div className="ac__navbar-links">
        <div className="ac__navbar-links_logo">
          <img className="ac__navbar__logo"src={logo} alt="" />
        </div>
        <div className="ac__navbar-links_container">
          <Menu />
        </div>
      </div>

      <div className="ac__navbar-menu">
        {/* add mobile menu  . icon setting and close */}
        {toggleMenu ? (
          <RiCloseLine
            color="#fff"
            size={27}
            onClick={() => setToggleMenu(false)}
          /> //
        ) : (
          <RiMenu3Line
            color="#fff"
            size={27}
            onClick={() => setToggleMenu(true)}
          />
        )}

        {/* to navbar content mobile menu appear  */}
        {toggleMenu && (
          <div className="ac__navbar-menu_container scale-up-center">
            <div className="ac__navbar-menu_container-links">
              <Menu />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Navbar
